import { StyleSheet, View } from "react-native";
import {
  getHomeCategories,
  getHomeInstaPosts,
  getHomePageData,
  getHomeStories,
  getVideos,
} from "appRedux/reducers/homeSlice";
import { router, useLocalSearchParams } from "expo-router";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import { ActivityIndicator } from "react-native-web";
import { Colors } from "colors";
import Edits from "../src/components/Home/Edits";
import ForYou from "../src/components/Home/ForYou";
import { Helmet } from "react-helmet";
import HomeCategories from "../src/components/Home/NewArrivals";
import HomePreferencesBanner from "../src/components/Home/setPreferencesCop";
import HomeStories from "../src/components/Home/HomeStories";
import HomeVideos from "components/Home/HomeVideos";
import ParentScrollView from "components/ParentScrollView";
import ShopByCategories from "../src/components/Home/ShopByCategories";
import SocialSection from "../src/components/Home/SocialSection";
import Trending from "../src/components/Home/Trending";
import { analytics } from "utils/firebaseConfig";
import { setUserProperties } from "firebase/analytics";
import { trackV2 } from "utils/Segment";
import { getFavProducts } from "appRedux/reducers/productSlice";
import AsyncStorage from "@react-native-async-storage/async-storage";

const Home = (props) => {
  const dispatch = useDispatch();
  const [homeStoriesLoading, setHomeStoriesLoading] = useState(false);
  const [homeDataLoading, setHomeDataLoading] = useState(false);
  const [shopByCategoriesLoading, setShopByCategoriesLoading] = useState(false);

  const homeData = useSelector((state) => state.HomeReducer.homeData) || [];
  const instaPostsLoading =
    useSelector((state) => state.HomeReducer.instaPostsLoading) || false;
  const homeVideosLoading =
    useSelector((state) => state.HomeReducer.homeVideosLoading) || false;
  const userProfile = useSelector((state) => state.ProfileReducer.profileData);

  const local = useLocalSearchParams();
  const gender = local?.gender || "female";

  useEffect(() => {
    const eventData = {
      default_section: gender,
    };
    trackV2(ANALYTICS_EVENT_NAMES.HOME_VIEWED, eventData);
    AsyncStorage.setItem(
      "gender",
      gender == "men" ? "male" : gender || "female"
    );
  }, [gender]);

  useEffect(() => {
    if (userProfile) {
      setUserProperty("user_id", userProfile?.userId);
      setUserProperty("user_name", userProfile?.name);
    }
    setHomeStoriesLoading(true);
    setHomeDataLoading(true);
    setShopByCategoriesLoading(true);
    dispatch(getHomeStories({ gender: gender ?? "female", size: 6 })).then(
      () => {
        setHomeStoriesLoading(false);
      }
    );
    dispatch(getHomePageData({ gender: gender ?? "female" })).then(() => {
      setHomeDataLoading(false);
    });
    dispatch(getHomeCategories({ gender: gender ?? "female" })).then(() => {
      setShopByCategoriesLoading(false);
    });
    dispatch(getHomeInstaPosts({ gender: gender ?? "female" }));
    dispatch(getVideos({ page: 1, size: 3, gender }));
    dispatch(getFavProducts());
  }, [gender]);

  const setUserProperty = (name, value) => {
    setUserProperties(analytics, { [name]: value });
  };

  const returnArray = (data) => {
    const orderMapping = {
      "New Arrivals": 0,
    };
    const sortedData = [...data]?.sort(
      (a, b) => orderMapping[a.optionName] - orderMapping[b.optionName]
    );
    return sortedData;
  };

  const renderItemNewArrivals = (item, index) => {
    if (item?.products.length === 0) {
      return null;
    }

    if ([1].includes(item?.optionId)) {
      return (
        <View key={item?.optionName}>
          <HomeCategories data={item} {...props} gender={gender} />
        </View>
      );
    }

    return <></>;
  };

  const renderItemForYou = (item, index) => {
    if (item?.products.length === 0) {
      return null;
    }

    if ([3].includes(item?.optionId)) {
      return (
        <View key={item?.optionName}>
          <ForYou data={item} {...props} gender={gender} />
        </View>
      );
    }

    return <></>;
  };
  const renderItemTrending = (item, index) => {
    if (item?.products.length === 0) {
      return null;
    }

    if ([6].includes(item?.optionId)) {
      return (
        <View key={item?.optionName}>
          <Trending data={item} {...props} gender={gender} />
        </View>
      );
    }

    return <></>;
  };
  return (
    <ParentScrollView gender={gender}>
      <View style={styles.container}>
        <>
          {/* Home Stories */}
          {homeStoriesLoading ? (
            <View style={styles.loadingContainer}>
              <ActivityIndicator size="large" color={Colors.black} />
            </View>
          ) : (
            <HomeStories gender={gender} />
          )}

          {/* New Arrivals */}
          {homeDataLoading ? (
            <View style={styles.loadingContainer}>
              <ActivityIndicator size="large" color={Colors.black} />
            </View>
          ) : (
            returnArray(homeData).length > 0 &&
            returnArray(homeData).map((item, index) => {
              return renderItemNewArrivals(item, index);
            })
          )}

          {/* Shop By Categories */}
          {shopByCategoriesLoading ? (
            <View style={styles.loadingContainer}>
              <ActivityIndicator size="large" color={Colors.black} />
            </View>
          ) : (
            <ShopByCategories />
          )}

          {/* For You Section with preferences banner */}

          {userProfile?.userId && !userProfile?.isGuest && (
            <>
              {userProfile?.isPreferences ? (
                homeDataLoading ? (
                  <View style={styles.loadingContainer}>
                    <ActivityIndicator size="large" color={Colors.black} />
                  </View>
                ) : (
                  returnArray(homeData).length > 0 &&
                  returnArray(homeData).map((item, index) =>
                    renderItemForYou(item, index)
                  )
                )
              ) : (
                <HomePreferencesBanner gender={gender} />
              )}
            </>
          )}

          {/* Edits Section */}
          {homeStoriesLoading ? (
            <View style={styles.loadingContainer}>
              <ActivityIndicator size="large" color={Colors.black} />
            </View>
          ) : (
            <Edits gender={gender} />
          )}

          {/* Home Videos Section */}
          {homeVideosLoading ? (
            <View style={styles.loadingContainer}>
              <ActivityIndicator size="large" color={Colors.black} />
            </View>
          ) : (
            <HomeVideos gender={gender} />
          )}

          {/* Trending Section */}
          {homeDataLoading ? (
            <View style={styles.loadingContainer}>
              <ActivityIndicator size="large" color={Colors.black} />
            </View>
          ) : (
            returnArray(homeData).length > 0 &&
            returnArray(homeData).map((item, index) => {
              return renderItemTrending(item, index);
            })
          )}

          {/* Social Section (Instagram posts) */}
          {instaPostsLoading ? (
            <View style={styles.loadingContainer}>
              <ActivityIndicator size="large" color={Colors.black} />
            </View>
          ) : (
            <SocialSection />
          )}
        </>
      </View>
    </ParentScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "white",
  },
  loadingContainer: {
    height: 500,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default Home;
